import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Check from 'wix-ui-icons-common/Check';
import styles from './ToggleButtons.scss';
import { Text } from 'wix-style-react';

export default class ToggleButtons extends Component {
  static displayName = 'ToggleButtons';

  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        value: PropTypes.any,
      }),
    ).isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
  };

  render() {
    const buttons = this._getButtons();
    return <div className={classNames([styles.wrapper, this.props.className])}>{buttons}</div>;
  }

  _getButtons() {
    const { options, value } = this.props;

    return options.map(option => (
      <button
        type={'button'}
        key={option.id}
        name={option.id}
        className={`${styles.button} ${option.id === value ? styles.selected : ''}`}
        onClick={() => this.props.onChange(option.id)}
        data-hook={`toggle-button-${option.id}`}
      >
        <Text size="medium" weight="normal" secondary>
          {option.value}
        </Text>
        <div className={styles.border}>
          <div className={styles.icon}>
            <Check style={{ fill: 'white' }} />
          </div>
        </div>
      </button>
    ));
  }
}
